module.exports = __webpack_public_path__ + "static/media/sarasx-logo-poweredby-dark-bg.4022e527.svg";